exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".uploader{position:relative}", "", {"version":3,"sources":["c:/Users/renjunying/Downloads/vue-uploader-master/vue-uploader-master/src/components/uploader.vue"],"names":[],"mappings":"AACA,UACE,iBAAmB,CACpB","file":"uploader.vue","sourcesContent":["\n.uploader {\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cf5a649","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/uploader.vue
// module id = 67
// module chunks = 0